import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, APP_INITIALIZER, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AgmCoreModule } from 'agm-core-ivy';
import {
  OktaAuthModule, OktaConfig
} from '@okta/okta-angular';

import { AppComponent } from './app.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { IconModule } from '../app/shared/icon.module';
import { AppBreakpointsModule } from './app-breakpoints.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { AccountModule } from './modules/account/account.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { OnboardingModule } from './modules/onboarding/onboarding.module';
import { HomeDevicesModule } from './modules/home-devices/home-devices.module';
import { DeviceDiagnosticsModule } from './modules/device-diagnostics/device-diagnostics.module';
import { ClaimsSupportModule } from './modules/claims-support/claims-support.module';
import { TechServicesModule } from './modules/tech-services/tech-services.module';
import { AuthModule } from './modules/auth/auth.module';
import { TechSupportHistoryModule } from './modules/tech-support-history/tech-support-history.module';
import { HealthCheckModule } from './modules/health-check/health-check.module';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { QuillModule } from 'ngx-quill';
import { ADPModule } from './core/adp.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PocModule } from './modules/poc/poc.module';
import { CMSModule } from './modules/cms/cms.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TechSupportModule } from './modules/tech-support/tech-support.module';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import OktaAuth from '@okta/okta-auth-js';
import { CustomOktaCallbackComponent } from './modules/auth/components/okta-callback/oktaCallback.component';
import { DeductibleLookupModule } from './modules/deductible-lookup/deductible-lookup.module';

export const ENV = 'ENV';
import Quill from 'quill';
import { DocumentModule } from './modules/document/document.module';
import { UnderMaintenanceModule } from './modules/under-maintenance/under-maintenance.module';
import { CoverageModule } from './modules/coverage/coverage.module';
import { GenericContentPageModule } from './modules/generic-content-page/generic-content-page.module';



var Block : any = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);


const oktaAuth = new OktaAuth({
  clientId: window['pghconfig']?.okta.clientId,
  issuer: window['pghconfig']?.okta.issuer,
  redirectUri: window.location.origin + '/login/callback',
  scopes: window['pghconfig']?.okta.scopes
});
@NgModule({ declarations: [
        AppComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent], imports: [AccountModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDSRtBx0PHSJvDp2RmEYnT9ykmsI46g8iY',
            libraries: ['places'],
        }),
        MatGoogleMapsAutocompleteModule.forRoot('AIzaSyCQLLuk1ccwX8-dM0XRis6DB5idee1Y9KY'),
        NgxMaskDirective,
        NgxMaskPipe,
        AppBreakpointsModule,
        AppRoutingModule,
        AuthModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        CreditCardDirectivesModule,
        DashboardModule,
        FormsModule,
        HomeDevicesModule,
        DeviceDiagnosticsModule,
        IconModule,
        OnboardingModule,
        ReactiveFormsModule,
        TechServicesModule,
        ClaimsSupportModule,
        CoverageModule,
        TechSupportHistoryModule,
        TechSupportModule,
        GenericContentPageModule,
        UnderMaintenanceModule,
        ScrollingModule,
        CoreModule,
        PocModule,
        DocumentModule,
        DeductibleLookupModule,
        ADPModule.forRoot(null),
        OktaAuthModule.forRoot({ oktaAuth }),
        NgIdleKeepaliveModule.forRoot(),
        SharedModule,
        HealthCheckModule,
        QuillModule.forRoot(),
        CMSModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { floatLabel: 'always',
                hideRequiredMarker: false,
                subscriptSizing: 'static' } },
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
